import { render, staticRenderFns } from "./ShopCategoryComponent.vue?vue&type=template&id=eff54f38&"
import script from "./ShopCategoryComponent.vue?vue&type=script&lang=js&"
export * from "./ShopCategoryComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports